<script>
  export let filterTypes = [];
  export let deleteFilter = () => {};
  export let addFilter = () => {};

  let newFilter;
</script>

<div class="col table-responsive-sm" style="height: 300px; overflow: scroll;">
  <label for="newFilter" class="form-label">Filtre Tipleri</label>
  <div class="d-flex flex-row justify-content-center">
    <input
      type="text"
      class="form-control text-center"
      placeholder="Filtre Adı"
      bind:value={newFilter}
    />
  </div>
  <button
    on:click|preventDefault={addFilter(newFilter)}
    class="btn btn-success mt-2">Ekle</button
  >
  <table class="table-sm">
    <thead>
      <tr>
        <th class="w-100">Filtre Adı</th>
        <th class="w-25">İşlemler</th>
      </tr>
    </thead>
    <tbody>
      {#each filterTypes as filter}
        <tr>
          <td class="w-100"
            ><input
              type="text"
              class="form-control text-center"
              bind:value={filter.filter}
            />
          </td>
          <td class="w-25">
            <button
              on:click|preventDefault={deleteFilter(filter._id)}
              class="btn btn-danger">Sil</button
            ></td
          >
        </tr>
      {/each}
    </tbody>
  </table>
</div>
